"use client";

import {getLocalTimeZone, parseDate, today} from "@internationalized/date";
import {DateRangePicker} from "@nextui-org/react";
import {Label} from "flowbite-react";
import React, {useEffect, useRef, useState} from "react";
import DatePicker, {
  CalendarProps,
  DateObject,
  DatePickerProps
} from "react-multi-date-picker";
import Icon from "react-multi-date-picker/components/icon";
import InputIcon from "react-multi-date-picker/components/input_icon";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import {NeoButton} from "../neo-button/neo-button";
interface NeoDatePickerProps
  extends Omit<CalendarProps, "onChange">,
    Omit<DatePickerProps, "onChange"> {
  type?: "input" | "icon" | "range" | undefined;
  label?: any;
  errorMessage?: any;
  className?: string;
  showTime?: boolean;
  rangedefaultValue?: any;
  handleDateChange?: (date: DateRange | Date | Date[] | null) => void;
  allowFuture?: boolean;
  openCalenManually?: any;
}
export const NeoDatePicker: React.FC<NeoDatePickerProps> = ({
  type = "input",
  label,
  errorMessage,
  showTime,
  handleDateChange,
  rangedefaultValue,
  allowFuture = false,
  openCalenManually,
  ...props
}) => {
  const datePickerRef = useRef<any>();
  const setDefaultDateTimeRange = () => {
    const now = new Date();
    const defaultFrom = new DateObject({date: now}).set({
      hour: 0,
      minute: 0,
      second: 0
    });

    const defaultTo = new DateObject({date: now}).set({
      hour: 23,
      minute: 59,
      second: 59
    });

    if (
      !rangedefaultValue ||
      !rangedefaultValue.from ||
      !rangedefaultValue.to
    ) {
      return [defaultFrom, defaultTo];
    }

    const from = new DateObject(rangedefaultValue.from);
    const to = new DateObject(rangedefaultValue.to);

    return [from, to];
  };
  const [selectedRangeDates, setSelectedRangeDates] = useState<DateObject[]>(
    () => {
      return setDefaultDateTimeRange();
    }
  );
  useEffect(() => {
    if (type === "icon") {
      if (selectedRangeDates && selectedRangeDates.length === 2) {
        const from = selectedRangeDates[0]?.toDate();
        const to = selectedRangeDates[1]?.toDate();
        if (from && to) {
          //from.setHours(0, 0, 0, 0);
          const result: DateRange = {from, to};
          handleDateChange?.(result);
          // setSelectedRangeDates(e);
          // setSelectedRangeDates([from, to]);
        }
      }
    }
  }, [selectedRangeDates]);

  const onDateChange = (e: DateObject | DateObject[] | null) => {
    if (e instanceof DateObject) {
      handleDateChange?.(e?.toDate());
    } else if (Array.isArray(e) && e.length > 0 && e[0] instanceof DateObject) {
      if (props.range) {
        const from = e[0]?.toDate();
        const to = e[1]?.toDate();
        if (from && to) {
          //from.setHours(0, 0, 0, 0);
          const result: DateRange = {from, to};
          //handleDateChange?.(result);
          setSelectedRangeDates(e);
          // setSelectedRangeDates([from, to]);
        }
      } else {
        const result = e.map(x => x?.toDate());
        handleDateChange?.(result);
      }
    }
  };
  useEffect(() => {
    if (typeof openCalenManually === "function") {
      openCalenManually(datePickerRef);
    }
  }, []);
  const handleApplyClick = () => {
    datePickerRef?.current?.closeCalendar();
  };

  const onRangeDateChange = (event: any) => {
    if (event.start && event.end) {
      const startDate = new Date(
        event.start.year,
        event.start.month - 1,
        event.start.day
      );
      const endDate = new Date(
        event.end.year,
        event.end.month - 1,
        event.end.day
      );
      handleDateChange?.({from: startDate, to: endDate});
    }
  };

  const extractDateObjtostr = () => {
    const from = rangedefaultValue?.from ?? new Date();
    const to = rangedefaultValue?.to ?? new Date();

    return {
      start: parseDate(
        `${from.getFullYear()}-${String(from.getMonth() + 1).padStart(2, "0")}-${String(from.getDate()).padStart(2, "0")}`
      ),
      end: parseDate(
        `${to.getFullYear()}-${String(to.getMonth() + 1).padStart(2, "0")}-${String(to.getDate()).padStart(2, "0")}`
      )
    };
  };
  const getDateLimits = (isFuture = false) => {
    const tz = getLocalTimeZone();

    return {
      minValue: isFuture ? today(tz) : undefined, // restrict past when future allowed
      maxValue: isFuture ? undefined : today(tz) // restrict future when false
    };
  };
  const {minValue, maxValue} = getDateLimits(allowFuture);
  return (
    <>
      {(() => {
        switch (type) {
          case "input": {
            return (
              <div className="grid w-full grid-cols-1">
                {label && (
                  <Label
                    className={`mb-1 block text-base font-normal ${errorMessage ? "text-red-500" : ""}`}
                    value={label}
                  />
                )}
                <DatePicker
                  {...props}
                  format={showTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD"}
                  onChange={onDateChange}
                  containerClassName="w-full [&_svg]:!right-3.5"
                  placeholder="Please select date"
                  render={
                    <InputIcon
                      // placeholder={props.placeholder}
                      // className={`border-neo-gray-100 h-unit-12 min-h-unit-12 w-full
                      //                       rounded-medium border-2 bg-neo-white px-3 shadow-none
                      //                       outline-none hover:border-neo-gray ${errorMessage && "!border-red-500"}`}
                      className={`border-neo-gray-100 h-11 min-h-11 w-full rounded-medium border-2 bg-neo-white px-3
shadow-none outline-none hover:border-neo-gray ${errorMessage && "!border-red-500"}`}
                    />
                  }
                  plugins={
                    showTime
                      ? [<TimePicker key="time-picker1" position="bottom" />]
                      : []
                  }
                />
                {errorMessage && (
                  <span className="p-1 text-tiny text-danger">
                    {errorMessage}
                  </span>
                )}
              </div>
            );
          }
          case "range": {
            return (
              <DateRangePicker
                defaultValue={extractDateObjtostr()}
                onChange={onRangeDateChange}
                label={label}
                //maxValue={today(getLocalTimeZone())}
                minValue={minValue}
                maxValue={maxValue}
                variant="bordered"
              />
            );
          }
          case "icon": {
            return (
              <div>
                <DatePicker
                  {...props}
                  value={selectedRangeDates}
                  range={true}
                  ref={datePickerRef}
                  format={showTime ? "MM-DD-YYYY HH:mm:ss" : "MM-DD-YYYY"}
                  onChange={onDateChange}
                  render={<Icon className="text-neo-gray" />}
                  //minDate={minValue}
                  //    minDate={minValue}
                  maxDate={!allowFuture ? new Date() : undefined}
                  plugins={
                    showTime
                      ? [
                          <TimePicker key="time-picker2" position="bottom" />,
                          <DatePanel key="time-picker3" markFocused />
                        ]
                      : []
                  }
                >
                  <div className="flex">
                    <p className="mb-1 ml-5 text-xs text-blue-800">
                      * Future dates and times are not allowed.
                    </p>
                  </div>
                  <div className="mx-2 flex justify-end gap-2">
                    <NeoButton
                      className=" mb-2"
                      type="submit"
                      color="black"
                      onClick={handleApplyClick}
                      size="sm"
                    >
                      Apply
                    </NeoButton>
                    <NeoButton
                      className="mb-2"
                      type="submit"
                      color="white"
                      onClick={handleApplyClick}
                      size="sm"
                    >
                      Close
                    </NeoButton>
                  </div>
                </DatePicker>
              </div>
            );
          }
          default: {
            return <span className="text-neo-red">Error</span>;
          }
        }
      })()}
    </>
  );
};
